import type { ReactNode } from 'react';
import { cx } from './cx';

/** govuk/components/details (native <details>; no polyfill needed in supported browsers). */
export function Details({ summary, children, open, className, id }: { summary: ReactNode; children: ReactNode; open?: boolean; className?: string; id?: string }) {
  return (
    <details id={id} className={cx('govuk-details', className)} data-module="govuk-details" open={open}>
      <summary className="govuk-details__summary">
        <span className="govuk-details__summary-text">{summary}</span>
      </summary>
      <div className="govuk-details__text">{children}</div>
    </details>
  );
}
